import { useId, useLayoutEffect } from 'react';
import { requestLoading, releaseLoading } from '@/lib/loading/loadingCoordinatorStore';
import type { LoadingSource } from '@/lib/loading/types';

/**
 * Registers a coordinator loading request while `active` is true.
 * Uses useLayoutEffect so release/request commit before browser paint —
 * avoids one-frame stale overlay after content becomes usable.
 */
export function useLoadingRequest(
  source: LoadingSource,
  active: boolean,
  options?: { routePath?: string; label?: string; idSuffix?: string },
): void {
  const reactId = useId();
  const requestId = `${source}:${options?.idSuffix ?? reactId}`;

  useLayoutEffect(() => {
    if (!active) return;
    requestLoading({
      id: requestId,
      source,
      routePath: options?.routePath,
      label: options?.label,
    });
    return () => {
      releaseLoading(requestId);
    };
  }, [active, requestId, source, options?.routePath, options?.label]);
}
